var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75,15c0,-0.414 0.336,-0.75 0.75,-0.75c0.414,0 0.75,0.336 0.75,0.75l-0,7c0,0.414 -0.336,0.75 -0.75,0.75c-0.414,0 -0.75,-0.336 -0.75,-0.75l-0,-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,19.25c-0.414,0 -0.75,-0.336 -0.75,-0.75c-0,-0.414 0.336,-0.75 0.75,-0.75l7,0c0.414,0 0.75,0.336 0.75,0.75c-0,0.414 -0.336,0.75 -0.75,0.75l-7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,1.25c3.036,0 5.5,2.464 5.5,5.5c0,3.036 -2.464,5.5 -5.5,5.5c-3.036,0 -5.5,-2.464 -5.5,-5.5c0,-3.036 2.464,-5.5 5.5,-5.5Zm0,1.5c-2.208,0 -4,1.792 -4,4c0,2.208 1.792,4 4,4c2.208,-0 4,-1.792 4,-4c0,-2.208 -1.792,-4 -4,-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,22.75c-0.241,-0 -0.456,-0.114 -0.594,-0.292c-0.075,-0.09 -0.132,-0.208 -0.15,-0.363c-0.004,-0.03 -0.006,-0.062 -0.006,-0.095c0,-0.004 0,-0.008 0,-0.012l-0,-0.988c-0,-4.28 3.47,-7.75 7.75,-7.75l5.5,0c0.414,-0 0.75,0.336 0.75,0.75c0,0.414 -0.336,0.75 -0.75,0.75l-5.5,-0c-3.452,0 -6.25,2.798 -6.25,6.25l0,0.988c0,0.708 -0.75,0.762 -0.75,0.762Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.b5ab15808f1ddf07952d5ec3da0fe1ce.svg";
export { ForwardRef as ReactComponent };